<template>

    <v-card class="object-item-info" v-if="selectedObjectObj && selectedItemObj" max-width="300" min-width="200">
        <span class="card-title">{{ `${selectedObjectObj.object_name} - ${selectedItemObj.item_name}` }}</span>
        <v-card-text>
            <template v-for="field in selectedItemObj.item_field_values">
                <div class="object-item-info-text-container">
                    <span class="label">{{ field.field_name }}</span>
                    <span class="value">{{ field.item_field_value }}</span>
                </div>
            </template>
        </v-card-text>
    </v-card>

</template>

<script>
export default {
    name: 'CommonObjectItemInfo',
    props: ['nodeValue', 'objectId', 'itemId', 'commonObjects'],
    components: {
    },
    data: () => ({
        value: null,
        selectedObjectId: null,
        selectedItemId: null
    }),

    computed: {
        selectedObjectObj() {
            if(this.selectedObjectId) {
                return this.$props.commonObjects.find(c => c.object_id == this.selectedObjectId);
            }
            return null;
        },

        selectedItemObj() {
            if(this.selectedObjectId && this.selectedItemId) {
                return this.selectedObjectObj.items.find(i => i.item_id == this.selectedItemId);
            }
            return null;
        },

        objectItems() {
            if(this.selectedObjectId) {
                return this.$props.commonObjects.find(c => c.object_id == this.selectedObjectId).items;
            }
            return [];
        }
    },

    methods: {
    },

    created() {
    },

    mounted() {
        if(this.$props.itemId != -1) {
            this.selectedObjectId = this.$props.objectId;
            this.selectedItemId = this.$props.itemId;
        }
        
    },

    watch: {

    },

  
};
</script>

<style scoped>

    .object-item-info {
        border: solid 1px rgba(0, 255, 255, 0.3);
    }

    .object-item-info .card-title {
        font-size: 15px;
        font-weight: bold;
        padding-top: 10px;
        text-align: center;
        display: block;
    }

    .object-item-info .object-item-info-text-container {
        display: block;
        background-color: #3B3B3B;
        margin-bottom: 5px;
        padding: 6px 8px;
    }
    .object-item-info .object-item-info-text-container .label {
        color: rgba(255, 255, 255, 0.7);
        font-size: 12px;
        display: block;
    }
    .object-item-info .object-item-info-text-container .value {
        color: #ffffff;
        font-size: 16px;
        display: block;
    }

    .arrow {
        width: 0;
        height: 0;
        border-top: 15px solid transparent;
        border-bottom: 15px solid transparent;
        border-right: 15px solid #00ffff;
        transform: rotate(90deg);
        position: absolute;
        top: 20px;
        left: 20px;
        z-index: 9999999999999;
        display: block;
    }
    .arrow::after {
        content: '';
        width: 0;
        height: 0;
        border-top: 15px solid transparent;
        border-bottom: 15px solid transparent;
        border-right: 15px solid #424242;
        position: absolute;
        top: -15px;
        left: 1px;
    }

</style>


